import * as Routes from "routes";


export const MOUNTED_ROUTE_PATHS: string[] = [
  Routes.hub,
  Routes.article,
  Routes.whatsNew,
  Routes.developerApiKeys,
  Routes.legacyDeveloperApiKeys,
  Routes.developerUsage,
  Routes.developerApiKeysEditKey,
  Routes.docsPage,
  Routes.legacyDocsPage,
  Routes.dataDashboard,
  Routes.dataCatalogue,
  Routes.demosPage,
  Routes.dataCatalogueEntry,
  Routes.dataExplorer,
  Routes.clip,
  Routes.clipUi,
  Routes.clipManagement,
  Routes.legacyClipManagement,
  Routes.verify,
  Routes.verifyGeocoder,
  Routes.dataCustomDownload,
  Routes.dataTailor,
  Routes.dataDownload,
  Routes.verifyStudio,
  Routes.verifyStudioCreate,
  Routes.legacyBatchBatches,
  Routes.legacyBatchCreateBatch,
  Routes.userPendingInvitations,
  Routes.userSecurity,
  Routes.userGeneralSettings,
  Routes.legal,
  Routes.testError,
  Routes.orgGeneralSettings,
  Routes.orgMembers,
  Routes.orgSubscription,
  Routes.orgFeatureComparisonTable,
  Routes.orgFeatureCostTable,
  Routes.orgBillingDetails,
  Routes.orgManageSubscription,
  Routes.legacyOrgManageSubscription,
  Routes.orgMemberDetails,
  Routes.adminOrganisations,
  Routes.adminDemoManagement,
  Routes.adminEditDemo,
  Routes.adminUsers,
  Routes.adminUserDetails,
  Routes.AdminMemberDetails,
  Routes.adminReleases,
  Routes.adminEditRelease,
  Routes.adminReleaseDatasets,
  Routes.adminDatasets,
  Routes.adminClipReporting,
  Routes.adminViewCustomDatasets,
  Routes.adminOrganisationDetails,
  Routes.adminOrganisationDetailsSubTab,
  Routes.adminOrganisationDetailsSubTabEdit,
  Routes.salesToolsRuralSchedule,
  Routes.salesToolsOpportunities,
  Routes.salesToolsOpportunitiesCreate,
  Routes.salesToolsOpportunitiesEdit,
  Routes.salesToolsOpportunitiesDetail,
];
